module.exports = __webpack_public_path__ + "media/images/stock_groups/e870-60de45d608fcf55b7f132489d7792b79.svg";